exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,400,600,700,800);", ""]);

// module
exports.push([module.id, "body{margin:0;padding:0;font-family:\"Open Sans\", sans-serif !important;background-color:#f1f1f1}.badge{float:right}\n", ""]);

// exports
